export const REG_DOC_TRANSLATION_NAMESPACE = 'features/regulatorydocuments';
export const REGULATION_ATTACHMENT_CATEGORY_NAME = 'Quelldokument';
